function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 8.00001C18 6.8954 18.8954 6 20 6C18.8955 6 18 5.10457 18 4C18 5.10454 17.1046 6 16 6C17.1045 6 18 6.89537 18 8.00001Z",
  fill: "#037BFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 10C18.5 10.8284 17.8284 11.5 17 11.5C17.8284 11.5 18.5 12.1716 18.5 13C18.5 12.1715 19.1716 11.5 20 11.5C19.1715 11.5 18.5 10.8284 18.5 10Z",
  fill: "#037BFF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11 9.99998C11 8.34312 12.3431 6.99999 14 6.99999C12.3431 6.99999 11 5.65686 11 4C11 5.65686 9.65686 6.99999 8 6.99999C9.65686 6.99999 11 8.34315 11 9.99998Z",
  fill: "#037BFF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15 7L4 18L6 20L17 9L15 7ZM13.293 10.207L14.707 8.79299L15.207 9.293L13.793 10.707L13.293 10.207Z",
  fill: "#037BFF"
});

function SvgMagicWand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWand);
export default __webpack_public_path__ + "static/media/magic-wand.004c95de.svg";
export { ForwardRef as ReactComponent };